<template>
  <section>
    <div class="row mt-3">
      <div class="col-12">
        <b-list-group>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :href="file.url"
            v-for="(file, index) in files"
          >
            {{ index + 1 }}. {{ file.label }}
            <b-icon icon="file-earmark-text" font-scale="2"></b-icon>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from 'vue'

import { IconsPlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'

Vue.use(IconsPlugin)
Vue.use(ListGroupPlugin)

export default {
  name: "stop-killing-and-release-animals",
  data() {
    return {
      files: [
        {
          label: '戒殺放生 （淨空法師）',
          url: 'https://www2.budaedu.org/official-website-data/love-life/article/stop-killing-and-release-animals/stop-killing-and-release-animals.pdf'
        },
        {
          label: '律航法師文記 （律航法師）',
          url: 'https://www2.budaedu.org/official-website-data/love-life/article/stop-killing-and-release-animals/master-lv-hang-writings.pdf'
        },
        {
          label:'放生殺生現報錄 （印光大師鑑定）',
          url: 'https://www2.budaedu.org/official-website-data/love-life/article/stop-killing-and-release-animals/the-record-of-releasing-and-killing-lives.pdf'
        },
        {
          label: '因果可轉變 （李炳南老居士）',
          url: 'https://www2.budaedu.org/official-website-data/love-life/article/stop-killing-and-release-animals/cause-and-effect-can-be-changed.pdf'
        },
        {
          label: '戒殺問白話 （周安士居士述 凡夫白話）',
          url: 'https://www2.budaedu.org/official-website-data/love-life/article/stop-killing-and-release-animals/questions-on-stopping-killing.pdf'
        },
        {
          label: '放生儀軌',
          url: 'https://www2.budaedu.org/official-website-data/love-life/article/stop-killing-and-release-animals/liberation-ritual.pdf'
        }
      ]
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>